import { Fragment } from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export default function NotAuthorized() {

    return (
        <Fragment>
            <Stack spacing={1}>
                <Typography
                    sx={{
                        fontWeight: 'bold',
                        pl: 2,
                        pr: 1
                    }}
                >
                    You are not authorized for this application
                </Typography>
            </Stack>
        </Fragment>
    )

}
